import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core'; // Example for ngx-translate

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  constructor(private translateService: TranslateService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
  const currentLang = this.translateService.currentLang || 'ar-SA';

  const langMap: { [key: string]: string } = {
    'ar-SA': 'ar',
    'en-US': 'en',
  };

  const backendLang = langMap[currentLang] || 'ar';
    const modifiedReq = req.clone({
      headers: req.headers.set('lang', backendLang),
    });

    return next.handle(modifiedReq);
  }
}
